var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('services',{staticClass:"desktop"}),_c('swipe',{staticClass:"mobile"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }